import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-judges',
  templateUrl: './judges.component.html',
  styleUrls: ['./judges.component.css']
})
export class JudgesComponent implements OnInit {
  JudgesData: any
  ResultData: any
  name: any = "";
  typeList: any = [];
  typeFilter: any = "All";



  constructor(
    private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.typeList = [
      { label: "All", value: "All" },
      { label: "International Judge", value: "International Judge" },
      { label: "International Judge Candidate", value: "International Judge Candidate" },
      { label: "Continental Judge", value: "Continental Judge" },
      { label: "National Judge", value: "National Judge" },
    ];

  }

  ngOnInit(): void {
    this.getDetails()
  }

  getDetails() {
    const url = this.global.basePath + "common/circularlist?modelType=judges&search=" + this.name;
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      console.log(
        "🚀 ~ file: archers.component.ts ~ line 30 ~ ArchersComponent ~ this.global.GetRequest ~ res",
        res
      );
      const data = res[0].json.circular;
      this.JudgesData = data;
      this.ResultData = data;
      this.generateResult()
    });
  }

  FilterByName(e: any) {
    console.log(e, "target value");
    // this.getDetails();
    this.generateResult();
  }

  filterByType(event: any) {
  //  this.name = event.value;
    this.generateResult();
  }
  generateResult(){
    this.JudgesData = this.ResultData.filter((obj) => { return obj.certificateLevel == this.typeFilter || this.typeFilter=="All" });
    if(this.name!=''){
      this.JudgesData = this.JudgesData.filter((obj) => { return obj.fullName.toLowerCase().includes(this.name.toLowerCase())});
    }
    this.JudgesData= this.JudgesData.sort(function(a,b){return a.fullName-b.fullName});
  }

  ClearFilters() {
    this.name = "";
    this.typeFilter="All"
    this.generateResult();
  
    // this.getDetails();
  }

}
